export enum OfficeEquipmentTypeSortType {
  Id,
  Name,
  IsDeleted
}